import { useState, useEffect } from "react";

const breakpoints = {
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
};

export default function useResponsive() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    let raf;
    const handleResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setWidth(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return {
    width,
    isMobile: width < breakpoints.sm,
    isTablet: width >= breakpoints.sm && width < breakpoints.md,
    isSmallDesktop: width >= breakpoints.md && width < breakpoints.lg,
    isDesktop: width >= breakpoints.lg,
    isCompact: width < breakpoints.md,
    // Grid helpers
    settingsColumns: width < breakpoints.md ? "1fr" : "minmax(0, 1fr) minmax(0, 1fr)",
    statsColumns: width < breakpoints.sm ? "repeat(2, 1fr)" : width < breakpoints.md ? "repeat(3, 1fr)" : "repeat(auto-fit, minmax(140px, 1fr))",
    planColumns: width < breakpoints.sm ? "1fr" : "repeat(2, 1fr)",
    teamColumns: width < breakpoints.sm ? "1fr" : width < breakpoints.md ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
    captureColumns: width < breakpoints.sm ? "repeat(2, 1fr)" : width < breakpoints.md ? "repeat(3, 1fr)" : "repeat(5, 1fr)",
    contentPadding: width < breakpoints.sm ? "16px 12px" : width < breakpoints.md ? "20px 20px" : "24px 28px",
  };
}
